module.exports = __webpack_public_path__ + "static/media/Banner.d3f2787f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/contact/Banner.png
// module id = 438
// module chunks = 0